<template>
  <BaseIcon
    :active="active"
    :dark-mode="darkMode"
    :width="width"
    :height="height"
    :svg-path="'M7.75 1.75H12.25C12.4489 1.75 12.6397 1.82902 12.7803 1.96967C12.921 2.11032 13 2.30109 13 2.5V4H7V2.5C7 2.30109 7.07902 2.11032 7.21967 1.96967C7.36032 1.82902 7.55109 1.75 7.75 1.75ZM5.5 2.5V4H3.625C2.72989 4 1.87145 4.35558 1.23851 4.98851C0.605579 5.62145 0.25 6.47989 0.25 7.375V15.625C0.25 16.5201 0.605579 17.3785 1.23851 18.0115C1.87145 18.6444 2.72989 19 3.625 19H16.375C17.2701 19 18.1285 18.6444 18.7615 18.0115C19.3944 17.3785 19.75 16.5201 19.75 15.625V7.375C19.75 6.47989 19.3944 5.62145 18.7615 4.98851C18.1285 4.35558 17.2701 4 16.375 4H14.5V2.5C14.5 1.90326 14.2629 1.33097 13.841 0.90901C13.419 0.487053 12.8467 0.25 12.25 0.25H7.75C7.15326 0.25 6.58097 0.487053 6.15901 0.90901C5.73705 1.33097 5.5 1.90326 5.5 2.5ZM18.25 8.5C18.25 9.09674 18.0129 9.66903 17.591 10.091C17.169 10.5129 16.5967 10.75 16 10.75H12.25V10.375C12.25 10.0766 12.1315 9.79048 11.9205 9.5795C11.7095 9.36853 11.4234 9.25 11.125 9.25H8.875C8.57663 9.25 8.29048 9.36853 8.0795 9.5795C7.86853 9.79048 7.75 10.0766 7.75 10.375V10.75H4C3.40326 10.75 2.83097 10.5129 2.40901 10.091C1.98705 9.66903 1.75 9.09674 1.75 8.5V7.375C1.75 6.87772 1.94754 6.40081 2.29917 6.04917C2.65081 5.69754 3.12772 5.5 3.625 5.5H16.375C16.8723 5.5 17.3492 5.69754 17.7008 6.04917C18.0525 6.40081 18.25 6.87772 18.25 7.375V8.5ZM7.75 12.25V12.625C7.75 12.9234 7.86853 13.2095 8.0795 13.4205C8.29048 13.6315 8.57663 13.75 8.875 13.75H11.125C11.4234 13.75 11.7095 13.6315 11.9205 13.4205C12.1315 13.2095 12.25 12.9234 12.25 12.625V12.25H16C16.8116 12.2512 17.6015 11.9879 18.25 11.5V15.625C18.25 16.1223 18.0525 16.5992 17.7008 16.9508C17.3492 17.3025 16.8723 17.5 16.375 17.5H3.625C3.12772 17.5 2.65081 17.3025 2.29917 16.9508C1.94754 16.5992 1.75 16.1223 1.75 15.625V11.5C2.377 11.971 3.1555 12.25 4 12.25H7.75Z'" />
</template>

<script>
import BaseIcon from "./BaseIcon.vue"
export default {
  components: {
    BaseIcon
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    darkMode: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: 22
    },
    height: {
      type: [Number, String],
      default: 22
    }
  }
}
</script>
